import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end align-items-center" }

import { computed } from "vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";

type LabelType = "success" | "notice" | "danger";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerifiedStatusLabel',
  props: {
  type: {
    type: String as () => LabelType,
    default: "notice"
  },
  text: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;



const icon = computed(
  () =>
    ({
      success: "check-circle",
      notice: "circle",
      danger: "alert-circle"
    }[props.type] || "")
);
const labelClass = computed(
  () =>
    ({
      success: "text-green",
      notice: "text-yellow",
      danger: "text-red"
    }[props.type] || "text-primary")
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (icon.value)
      ? (_openBlock(), _createBlock(FeatherIcon, {
          key: 0,
          icon: icon.value,
          size: "1x",
          class: _normalizeClass(labelClass.value)
        }, null, 8, ["icon", "class"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createElementVNode("p", {
      class: _normalizeClass(["text-size-14 ml-1", labelClass.value])
    }, _toDisplayString(__props.text), 3)
  ]))
}
}

})